import { render, staticRenderFns } from "./CrearCampoDatosModal.vue?vue&type=template&id=1f22584b&"
import script from "./CrearCampoDatosModal.vue?vue&type=script&lang=ts&"
export * from "./CrearCampoDatosModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1f22584b', component.options)
    } else {
      api.reload('1f22584b', component.options)
    }
    module.hot.accept("./CrearCampoDatosModal.vue?vue&type=template&id=1f22584b&", function () {
      api.rerender('1f22584b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfigurarBase/CrearCampoDatosModal.vue"
export default component.exports